<template>
  <div class="tabs-widget">
    <div class="tab-item" v-if="$checkPermission('event_streaming')" :class="{ active: activeTab == 'event_stream' }"
      @click="switchTab('event_stream')">
      EVENT STREAM
    </div>
    <div class="h-spacer" v-if="$checkPermission('tv_streaming')"></div>
    <div class="tab-item" v-if="$checkPermission('tv_streaming')" :class="{ active: activeTab == 'tv_stream' }"
      @click="switchTab('tv_stream')">
      TV STREAM</div>
    <div class="h-spacer" v-if="$checkPermission('event_streaming')"></div>
    <div class="tab-item" v-if="$checkPermission('event_streaming')" :class="{ active: activeTab == 'past_streaming' }"
      @click="switchTab('past_streaming')">
      PAST STREAM</div>
    <div class="h-spacer" v-if="$checkPermission('event_streaming')"></div>
    <div class="tab-item" v-if="$checkPermission('event_streaming')"
      :class="{ active: activeTab == 'streaming_location' }" @click="switchTab('streaming_location')">
      STREAM LOCATION</div>
  </div>
</template>

<script>
export default {
  components: {},
  sockets: {},
  props: {
    activeTab: {
      type: String,
      default: "",
    },
  },
  data: () => ({}),
  watch: {},
  mounted() {
    let vm = this;
  },
  methods: {
    switchTab(type) {
      let vm = this;
      vm.$emit("selected", type);
    },
  },
};
</script>
<style lang="scss" scoped>
.tabs-widget {
  display: flex;
  align-items: flex-end;
  margin-right: 15px;

  .h-spacer {
    margin-right: 20px;
  }

  .tab-item {
    cursor: pointer;
    padding: 14px 4px;
    border-bottom: 3px solid transparent;
    white-space: nowrap;

    &.active {
      color: var(--wecodefy-secondary-color, #9fc953);
      border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
    }
  }
}
</style>